import faker from 'faker';
import moment from 'moment';

export default {
  items: Array(10)
    .fill(0)
    .map((_, index) => {
      return {
        id: index,
        contrato: faker.random.number({ min: 1000, max: 5000 }),
        fornecedor: faker.name.findName(),
        analistaGpc: faker.name.firstName(),
        periodo: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
        statusMedicao: faker.lorem.word(),
        avanco: faker.random.number({ min: 0, max: 100 }),
        recebimentoDocAcessoria: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
        statusDocAcessoria: faker.lorem.word(),
        recebimentoBM: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
        valorBM: faker.random.number({ min: 1, max: 5, precision: 0.01 }).toFixed(2),
        statusBM: faker.lorem.word(),
        recebimentoSLA: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
        statusSLA: faker.lorem.word(),
        bonus: faker.random.number({ min: 1, max: 5, precision: 0.01 }).toFixed(2),
        penalti: faker.random.number({ min: 1, max: 5, precision: 0.01 }).toFixed(2),
        autorizacaoFaturamento: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
        emissaoNF: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
        previsaoPagamento: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
      };
    }),
  resume: [
    {
      contratosVigentes: faker.random.number({ min: 100, max: 500 }),
      medicoesRecebidas: faker.random.number({ min: 100, max: 500 }),
      medicoesPendentes: faker.random.number({ min: 100, max: 500 }),
      valorMedicoesConcluidas: faker.random.number({ min: 1000000, max: 9000000, precision: 0.01 }).toFixed(2),
    },
  ],
};
